import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

export function hasFilter(filter: CompositeFilterDescriptor | FilterDescriptor | undefined, field: string | undefined): boolean {
    if (!filter || !field) {
        return false;
    }

    if ('field' in filter) {
        return filter.field === field;
    }

    return (filter as CompositeFilterDescriptor).filters.some((x) => hasFilter(x, field));
}
